module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_c('a', {
    attrs: {
      "id": "pagev"
    }
  }), _vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc-preface",
    attrs: {
      "id": "toc-copyright"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/copyright",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-preface",
    attrs: {
      "id": "toc-introduction"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/introduction"
    }
  }, [_vm._v("Introduction to Envy (T. S. Berczynski)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part",
    attrs: {
      "id": "toc-part001"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/part001"
    }
  }, [_vm._v("Olesha // Envy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter001"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter001"
    }
  }, [_vm._v("Chapter I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter002"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter002"
    }
  }, [_vm._v("Chapter II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter003"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter003"
    }
  }, [_vm._v("Chapter III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter004"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter005"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter006"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter007"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter008"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter009"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter010"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter011"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter012"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter013"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter014"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter015"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter XV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part",
    attrs: {
      "id": "toc-part002"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/part002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Two")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter016"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter017"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter018"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter019"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter020"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter021"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter022"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter023"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter024"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter025"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter026"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapter",
    attrs: {
      "id": "toc-chapter027"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter XII")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3bbc574","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 63
// module chunks = 0